// Re-export only. The component lives in @aveo/ui so a module in its own
// repository can use the same one — there is no '@/' alias outside this repo.
// Keeping this file means the 9 places in the dashboard that already import
// '@/components/ui/button' do not have to change, and there is still exactly one
// definition.
export { Button, buttonVariants } from '@aveo/ui'
